import { render } from "./announcement.vue?vue&type=template&id=642035b3"
import script from "./announcement.js?vue&type=script&lang=js"
export * from "./announcement.js?vue&type=script&lang=js"

import "./announcement.vue?vue&type=style&index=0&id=642035b3&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__